import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { getUserInfoService } from "../services/PatientService";
import Loader from "../commonComponent/Loader";

function AvatarPopover({ data, onHover }) {
  const [user, setUser] = useState();
  const [isLoading, setLoader] = useState(true);
  const navigate = useNavigate();
  const auth = useAuth();
  const navigateToChat = () => {
    auth.createDialog(user);
    navigate(
      "/messages",
      { state: { route: "allpatientoverview", user: user } },
      { replace: true }
    );
  };

  useEffect(() => {
    // Make the API call when onHover is true
    if (onHover ) {
      getUserInfo();
    }
  }, [onHover, data._id]);

  const getUserInfo = async () => {
    try {
      const res = await getUserInfoService(data._id || data.user_id || data.userId);
      // console.log(res.data.data);
      if (res.status === 200) {
        setUser(res.data.data[0]);
        setLoader(false);
      } else {
        console.error(`Error fetching user info. Status: ${res.status}`);
      }
    } catch (error) {
      console.error("An error occurred while fetching user info:", error);
    }
  };
  


  return (
    <>
      {isLoading ? (
        <Loader
          visible={false}
          style={{ top: "-15px", position: "relative" }}
        />
      ) : (
        user && (
          <div className="avatar_detail">
            <div className="row">
              <div className="col-3">
                <p className="lf_avt">name:</p>
              </div>
              <div className="col-8">
                <p className="rt_avt">{user.full_name}</p>
              </div>
              <div className="col-3">
                <p className="lf_avt">DOB:</p>
              </div>
              <div className="col-8">
                <p className="rt_avt">{user.dob}</p>
              </div>
              <div className="col-3">
                <p className="lf_avt">Gender:</p>
              </div>
              <div className="col-8">
                <p className="rt_avt">{user.gender}</p>
              </div>
              <div className="col-3">
                <p className="lf_avt">Email:</p>
              </div>
              <div className="col-8">
                <p className="rt_avt">{user.email}</p>
              </div>
              <div className="col-3">
                <p className="lf_avt mb-0">Address:</p>
              </div>
              <div className="col-8">
                <p className="rt_avt mb-0">
                  {user.city} {user.state} {user.country}
                </p>
              </div>
              <div className="col-8 offset-4  d-flex justify-content-between">
                <a
                  className="avt_link"
                  onClick={() => {
                    navigate("/allpatientinfo", {
                      state: { user: user },
                    });
                  }}
                >
                  Quick Link
                </a>
                {/* <a className="avt_link">Send Message</a> */}
                {user.onBoarding ? (
                  <span onClick={() => navigateToChat()} className="link_text">
                    <p className="avt_link">Send Message</p>
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
}

export default AvatarPopover;
